import {Col, Row} from "antd";
import { Helmet } from "react-helmet";
import {
  Section1,
  Section2,
  Section3,
  Section4,
  Section5,
  Section6,
  Section7,
  Section8
} from "../../components/pages/Main";

export const MainPage = () => {
  return (
     <>
      <Helmet>
        <title>Онлайн-платформа для детей, родителей, педагогов |Развитие детей 0–6 лет</title>
        <meta name="description" content="Платформа для детей, родителей и педагогов: скрининг, самодиагностика, нейропсихология, консультации специалистов, задания, игры, мультфильмы, видео-уроки и статьи для развития ребёнка." />
      </Helmet>
    <Row>
      <Col span={24}>
        <Section1/>
      </Col>

      <Col span={24}>
        <Section2/>
      </Col>

      <Col span={24}>
        <Section4/>
      </Col>

      <Col span={24}>
        <Section5/>
      </Col>

      <Col span={24}>
        <Section7/>
      </Col>

      <Col span={24}>
        <Section8/>
      </Col>
    </Row>
    </>
  )
}